export default __webpack_public_path__ + "static/media/birth-plan-03.213649ae.png";